import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { TravelReimbursementModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-data.model';
import { AdminTravelReimbursementListingModel } from 'common/models/page-models/travel-reimbursement/admin-travel-grid-model';
import { AdminTravelReimbursementGridDataService } from 'common/services/data-services/admin/travel-reimbursement/travel-reimbursement-grid-data-service';
import { AdminTravelReimbursementGridMetaModel } from 'common/models/page-models/travel-reimbursement/admin-travel-grid-meta-model';

 
@Injectable({
    providedIn: 'root'
})
export class AdminTravelReimbursementGridWidgetService extends GridWidgetService<TravelReimbursementModel, AdminTravelReimbursementListingModel> {
    constructor(protected override ds: AdminTravelReimbursementGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new AdminTravelReimbursementGridMetaModel().getMetaModel();
        return meta;
    }

}